import { appConfig as $config } from '../../app.config';
import { Common } from '../../modules/Common';
import { App } from '../../modules/App';
import { UI } from '../../modules/UI';

export const PageSearch = (function () {
  let mapping = {
    filters: (data) => {
      return $.map(data, function (item) {
        return item.displayName;
      });
    },
    sortings: (data) => {
      return $.map(data, function (item) {
        return item.displayName;
      });
    }
  };

  let init = ({ filters = false, selector = false, submitprops = {}, pageName = '' } = {}) => {
    if (!selector) return;

    let uri = Common.segmentedURI();
    let page = pageName == '' ? (uri.page == '' ? $config.default.page : uri.page) : pageName;
    let filter = Common.getQueryVal('SearchColumn', submitprops.query ? submitprops.query : uri.query);
    let query = Common.getQueryVal('SearchValue', submitprops.query ? submitprops.query : uri.query) || '';
    let sorting = KTUtil.getParameterByName('OrderBy', submitprops.query ? submitprops.query : uri.query);

    let uid = `${Math.random()
      .toString(36)
      .replace(/[^a-z]+/g, '')
      .substr(2, 10)}`;
    if (!submitprops.nopageblock) UI.block('#page');
    $.when(App.ajaxData(`/system/prepare/filter?requestPageType=${page}`)).done((res) => {
      let filterItems = mapping.filters(res.filterItems);
      let sortItems = mapping.sortings(res.sortItems);
      let data = {
        uid: uid,
        filters: filterItems,
        filter: filter ? filterItems.indexOf(filter) : false,
        sortings: sortItems,
        sorting: sorting,
        query: query,
        submit: submit,
        reset: reset,
        submitprops: submitprops
      };
      let template = require(`./tmpl/SearchForm.hbs`);
      $(selector).append(template(data));
      $('select[name="sorting"]', $(selector)).select2({
        minimumResultsForSearch: 300
      });

      window[uid] = data;
      dataBinder.dataBind(document.body, window);

      if (!submitprops.nopageblock) UI.unblock('#page');
    });
  };

  let submit = (e) => {
    e.preventDefault();
    let $searchForm = $(e.target).closest('form');
    let uid = $('[name="uid"]', $searchForm).val();
    let query = $('[name="query"]', $searchForm).val();
    let filter = $('[name="filter"]', $searchForm).val();
    let sort = $('[name="sorting"]', $searchForm).val();
    //if (!query || !filter) return;
    let submitprops = window[uid].submitprops;
    if (submitprops.pagename) {
      let queryStr = Common.setQueryValues(
        submitprops.pagename,
        { key: 'SearchColumn', value: filter },
        { key: 'SearchValue', value: query },
        { key: 'OrderBy', value: sort }
      );
      return submitprops.submit(queryStr);
    }

    let queryStr = Common.setQueryValues(
      Common.segmentedURI().query,
      { key: 'SearchColumn', value: filter },
      { key: 'SearchValue', value: query },
      { key: 'OrderBy', value: sort }
    );
    if (!queryStr.startsWith('?')) queryStr = '?' + queryStr;
    $router.navigate(`/${Common.segmentedURI().page}${queryStr}`);
  };

  let reset = (e) => {
    let $searchForm = $(e.target).closest('form');
    let uid = $('[name="uid"]', $searchForm).val();
    let submitprops = window[uid].submitprops;
    if (submitprops.reset) {
      return submitprops.reset();
    }
    $router.navigate(`/${Common.segmentedURI().page}`);
  };

  return {
    init
  };
})();
